import {importSPKI} from 'jose';
import {JWT_ALGORITHM} from './constants';

let jwtPublicKey: Awaited<ReturnType<typeof importSPKI>>;

export async function initJwtPublicKey() {
  const _jwtPublicKey = process.env.JWT_PUBLIC_KEY as string;

  jwtPublicKey = await importSPKI(_jwtPublicKey, JWT_ALGORITHM);
}
export function getJwtPublicKey() {
  return jwtPublicKey;
}
